import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5008").replace(/\/+$/, "");
const API_ROOT_URL = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

const api = axios.create({
  baseURL: API_ROOT_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const tenantKey = localStorage.getItem("tenantKey") || sessionStorage.getItem("tenantKey");
  const nextConfig = { ...config };

  nextConfig.headers = nextConfig.headers || {};

  if (token) {
    nextConfig.headers.Authorization = `Bearer ${token}`;
  }
  
  if (tenantKey) {
    nextConfig.headers["x-tenant-key"] = tenantKey;
  }

  return nextConfig;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("tenantKey");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("tenantKey");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export { API_BASE_URL, API_ROOT_URL, api };